//id获取获取dom节点兼容safari
function getById(name) {
  if (document.getElementById(name)) {
    return document.getElementById(name);
  } else {

    return document.querySelector('#' + name);
  }
}
export default getById;


// WEBPACK FOOTER //
// ./src/common/js/utils/getById.js